import { render, staticRenderFns } from "./property-list-table.vue?vue&type=template&id=7afc03a4&scoped=true&"
import script from "./property-list-table.vue?vue&type=script&lang=js&"
export * from "./property-list-table.vue?vue&type=script&lang=js&"
import style0 from "./property-list-table.vue?vue&type=style&index=0&id=7afc03a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afc03a4",
  null
  
)

export default component.exports